'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withReflex = require('./withReflex');

var _withReflex2 = _interopRequireDefault(_withReflex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// For backwards-compatibility
// This will be deprecated in a later release
var Reflex = (0, _withReflex2.default)();

exports.default = Reflex;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reflexbox/dist/Reflex.js
 ** module id = 322
 ** module chunks = 0
 **/